import { Card, CardProps } from "@mui/material";
import { forwardRef } from "react";

/**
 * The canonical PT-skin card: flat (no shadow), 1px divider border, theme
 * radius (12px). This is the single source of truth for the "outlined, not
 * elevated" surface look — it replaces both the copy-pasted
 * `sx={{ border: "1px solid", borderColor: "divider", boxShadow: "none" }}`
 * and every `<Paper elevation>` / `<Card elevation>` scattered across the
 * workspaces.
 *
 * Pass `sx` to extend (padding, height, min-height, etc.); the outlined
 * signature is the base and callers may still override individual keys
 * (e.g. borderColor) because their `sx` is merged last.
 */
const SurfaceCard = forwardRef<HTMLDivElement, CardProps>(function SurfaceCard(
  { sx, elevation = 0, ...props },
  ref,
) {
  return (
    <Card
      ref={ref}
      elevation={elevation}
      sx={[
        { border: "1px solid", borderColor: "divider", boxShadow: "none" },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...props}
    />
  );
});

export default SurfaceCard;
